/**
 * Benefits Block.
 * 
 */

/**
 * Desktop: Scroll/wheel controls image slider on left and callout scroller on right.
 *	Powered by gsap.
 * Mobile: Image stacks on callout in a horizontal swipe slider.
 */

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

// Set up gsap tl, scrollTrigger for benefits slides in mobile.

let
	tl = null,
	pinner = null,
	tlTrigger = null,
	pinnerTrigger = null;

// Toggle gsap slider / slick slider at tablet-h (1024px)
let mobileUiThing = null,
	desktopUiThing = null;

exports.init = function () {
    // Run init methods...
    let browserW = $(window).width();

    // Initialize slick slider if page opened in mobile view (< 1024).
    // Initialize gsap scroller if page opened in desktop view (>= 1024).
 //    if (browserW >= 1024) {
	//     initDesktopScroller();
	// } else {
	// 	initMobileSlider();
	// }

	// Initialize slick slider on .mobile markup if page opened in or resized to mobile view.
	// Initialize gsap scroller on .desktop markup if page opened in or resized to desktop view.
	// Works with benefits-block-mobile-desktop.twig.
	initUiOnce();

	// initUi();

	// initMobileSlider();
 //    initDesktopScroller2();
};

function initUiOnce() { // *** KEEP ***
	// console.log('BENEFITS: initUiOnce()'); // TRACE.
	let mediaQuery = window.matchMedia(`(min-width: 1024px)`);
	setupInteractionOnce(mediaQuery); // Call handler at run time
	mediaQuery.addListener(setupInteractionOnce); // Attach listener
}
function setupInteractionOnce(mq) { // *** KEEP ***
	// console.log('BENEFITS: setupInteractionOnce()'); // TRACE.
	if (mq.matches && !desktopUiThing) {
		// Desktop
		// checkSlideParams();
		initDesktopUiOnce();    	// Create desktop UI
		// checkSlideParams();
	} else if (mq.matches && desktopUiThing) {
		// killMobileSlider2();		// Kill mobile UI
		enableDesktopScroller2();	// Enable scrolltrigger snapping.
	} else if (!mq.matches && !mobileUiThing) {
		// Mobile
		// checkSlideParams();
		initMobileUiOnce();    		 // Create mobile UI
		// checkSlideParams();
	}
	if (mq.matches && mobileUiThing) {
		// killMobileSlider2();		// Kill mobile UI
	}
	if (!mq.matches && desktopUiThing) {
		disableDesktopScroller2();	// Disable scrolltrigger snapping.
		// initMobileUiOnce();			// Init mobile UI
		// $('.slick-slide').removeAttr("style");
	}
}
function initMobileUiOnce() { // *** KEEP ***
	// console.log('BENEFITS: initMobileUiOnce()'); // TRACE.
	mobileUiThing = new Object();
	initMobileSlider2();
}
function initDesktopUiOnce() { // *** KEEP ***
	// console.log('BENEFITS: initDesktopUiOnce()'); // TRACE.
	desktopUiThing = new Object();
	initDesktopScroller2();
}

function disableDesktopScroller2() { // *** KEEP ***
	// console.log('BENEFITS: disableDesktopScroller2()'); // TRACE.
	tlTrigger.disable(true, false);
	// pinnerTrigger.disable(false, false);
}
function enableDesktopScroller2() { // *** KEEP ***
	// console.log('BENEFITS: enableDesktopScroller2()'); // TRACE.
	tlTrigger.enable(true);
	// pinnerTrigger.enable(false, false);
}

// Initializes gsap scroller for .desktop markup.
function initDesktopScroller2() { // *** KEEP ***
	// console.log('BENEFITS: initDesktopScroller2()'); // TRACE.

	// Set properties to be inherited by ALL tweens (that don't have inherit:false).
	// NB. Setting overwrite: 'auto' kills conflicting tweens.
	gsap.defaults({overwrite: 'auto'});

	// Set position (duration 0) of image slides (direct children of .benefits-block__image-slides).
	gsap.set(".desktop-st .benefits-block__image-slides > *", {xPercent: -50, yPercent: -50});

	// Array of .benefits-block__callout-slide-wrap elements (callouts markup).
	// Each wrap contains a callout. 1x viewport height.
	const contentMarkers = gsap.utils.toArray(".contentMarker");

	// Set up our scroll trigger
	const ST = ScrollTrigger.create({
		trigger: ".desktop-st .benefits-block__slides",		// Container of image and callout slides. 3x viewport height.
		start: "top top",									// Top of trigger at top of viewport.
		end: "bottom bottom",								// Bottom of trigger at bottom of viewport.
		onUpdate: getCurrentSection,						// Display matching callout slide.
		onLeave: setLastSection,							// Display matching callout slide.
		onLeaveBack: setFirstSection,						// Display matching callout slide.
		pin: ".desktop-st .benefits-block__image-slides",	// Image slides. 1x viewport height.
		// markers:true										// TRACE. Display markers for testing.
	});

	// console.log("contentMarker: "+contentMarkers[0].className); // TRACE.

	// Set up our content behaviors
	contentMarkers.forEach(marker => {

		// Select slide image divs based on id: #img1, $img2, $img3.
		// NB. markerContent is set via data-marker-content attribute in callout div .contentMarker.
		marker.content = document.querySelector(`#${marker.dataset.markerContent}`);
		// console.log("— marker.content: "+marker.content.id); // TRACE.

		// $(marker).parent().css('border','1px solid red');	// TRACE callouts.

		gsap.set(marker.content, {transformOrigin: "center"});
		// gsap.set(marker.content, {transformOrigin: "top left"});
		
		marker.content.enter = function() {
			// console.log("— marker.content.enter: "+marker.content.id); // TRACE.
			// console.log("— OPACITY: "+$(this).css('opacity')); // TRACE.
			if ($(this).css('opacity') == 0) {
				// console.log("— RUN ENTER: "+this.id); // TRACE.
				// gsap.fromTo(marker.content, {autoAlpha: 0, rotateY: -30}, {duration: 0.3, autoAlpha: 1, rotateY: 0});
				gsap.fromTo(marker.content, {autoAlpha: 0}, {duration: 0.50, autoAlpha: 1});
			}
		}
		
		marker.content.leave = function() {
			// console.log("— marker.content.leave: "+marker.content.id); // TRACE.
			// console.log("— OPACITY: "+$(this).css('opacity')); // TRACE.
			if ($(this).css('opacity') != 0) {
				// console.log("— RUN LEAVE: "+this.id); // TRACE.
				gsap.to(marker.content, {duration: 0.50, autoAlpha: 0});
			}
		}
		
	});

	// Handle the updated position
	let lastContent,
		// lastContent = contentMarkers[0].content,
		prevScroll,
		scrollDown = true,
		newContent,
		newMarker,
		firstScrollDown = true;	// Flag first time scroll into Benefits block (to prevent image animation flash).

	function setFirstSection() {
		// console.log('BENEFITS: setFirstSection()'); // TRACE.
		let firstMarker = contentMarkers[0],
			nextMarker = contentMarkers[1];

		// console.log('— total markers: '+contentMarkers.length); // TRACE.
		// console.log('— leave: '+nextMarker.content.id); // TRACE.
		// console.log('— enter: '+firstMarker.content.id); // TRACE.
		firstMarker.content.enter();
		nextMarker.content.leave();
		lastContent = firstMarker.content;
	}

	function setLastSection() {
		// console.log('BENEFITS: setLastSection()'); // TRACE.
		let lastMarker = contentMarkers[contentMarkers.length-1],
			nextMarker = contentMarkers[contentMarkers.length-2];

		// console.log('— total markers: '+contentMarkers.length); // TRACE.
		// console.log('— leave: '+nextMarker.content.id); // TRACE.
		// console.log('— enter: '+lastMarker.content.id); // TRACE.
		lastMarker.content.enter();
		nextMarker.content.leave();
		lastContent = lastMarker.content;
	}

	function setCurrentSection() {
		// console.log('BENEFITS: setCurrentSection()'); // TRACE.
		// Set lastContent and newContent values on page load.
		let firstMarker = contentMarkers[0],
			lastMarker = contentMarkers[contentMarkers.length - 1];

		if (scrollY < firstMarker.offsetTop + innerHeight/100) {
			lastContent = firstMarker.content;		// Assumes page loads at top of page. Begin w slide 1.
			newContent = firstMarker.content;		// Assumes page loads at top of page. Begin w slide 1.
			newMarker = firstMarker;				// Assumes page loads at top of page. Begin w slide 1.
		} else if (scrollY > lastMarker.offsetTop) {
			lastContent = lastMarker.content;		// Assumes page loads at after benefits. Begin w slide 3.
			newContent = lastMarker.content;		// Assumes page loads at after benefits. Begin w slide 3.
			newMarker = lastMarker;					// Assumes page loads at after benefits. Begin w slide 3.
		}
		// console.log("— setCurrentSection(): newContent: "+newContent.id);	// TRACE.
	}

	setCurrentSection();

	function getCurrentSection() {
		// console.log('BENEFITS: getCurrentSection()'); // TRACE.
		// let newContent, newMarker;
		const currScroll = scrollY,
			totalMarkers = contentMarkers.length;
		let myMarker,
			portOffset,
			myMarkerY,
			myMarkerSlideH;

		if ((currScroll-prevScroll) > 0) {scrollDown = true;}
		if ((currScroll-prevScroll) < 0) {scrollDown = false;}
		// if (scrollDown) {	// TRACE.
		// 	console.log("SCROLLING DOWN");
		// } else {
		// 	console.log("SCROLLING UP");
		// }

		// Find the current section
		if (scrollDown) {
			for (var i=0;i<totalMarkers;i++) {
				myMarker = contentMarkers[i];
				portOffset = myMarker.getBoundingClientRect();
				myMarkerY = portOffset.top + currScroll;
				myMarkerSlideH = parseInt($(myMarker).parent().css('height'));
				// console.log("scrollY / markerY / markerH: "+currScroll+" / "+myMarkerY+" / "+myMarkerSlideH);	// TRACE.
				// if(currScroll >= myMarker.offsetTop) {
				if(currScroll >= myMarkerY - myMarkerSlideH/2) {
					newContent = myMarker.content;
					newMarker = myMarker;
				}
			}
		} else {
			for(var i=totalMarkers-1;i>=0;i--) {
				myMarker = contentMarkers[i];
				portOffset = myMarker.getBoundingClientRect();
				myMarkerY = portOffset.top + currScroll;
				myMarkerSlideH = parseInt($(myMarker).parent().css('height'));
				// console.log("scrollY / markerY / markerH: "+currScroll+" / "+myMarkerY+" / "+myMarkerSlideH);	// TRACE.
				// if(currScroll >= myMarker.offsetTop) {
				if(currScroll >= myMarkerY - myMarkerSlideH/2) {
					newContent = myMarker.content;
					newMarker = myMarker;
					break;
				}
			}
		}
		// console.log("— getCurrentSection(): newContent: "+newContent.id);

		// Fade new marker based on y position in viewport.
		var viewportOffset = newMarker.getBoundingClientRect();
		// these are relative to the viewport, i.e. the window
		var newMarkerTop = viewportOffset.top;
		var newMarkerLeft = viewportOffset.left;

		var centerY = window.innerHeight/2;
		var delCenterY = newMarkerTop - centerY;
		var markerAlpha = Math.abs(delCenterY / centerY);	// Original.
		// var markerAlpha = (delCenterY / centerY);		// Mod 1.
		// newMarker.style.opacity = 0.25 + 1*(1 - markerAlpha);	// Original. Alpha is always > 0 (min 0.25).
		// newMarker.style.opacity = 1 + markerAlpha/2;	// Mod 1.
		newMarker.style.opacity = 0.25 + 1.5*(1 - markerAlpha);	// Mod 2.
		// console.log("— "+newMarker.dataset.markerContent+" OPACITY: "+newMarker.style.opacity); // TRACE.
		
		// If the current section is different than that last, animate in
		if(newContent
		&& (lastContent == null 
			 || !newContent.isSameNode(lastContent))) {
			// console.log("— (newContent && (lastContent == null || !newContent.isSameNode(lastContent)))"); // TRACE.
			// if (lastContent) { // TRACE.
			// 	console.log("— lastContent: "+lastContent.id);
			// } else {
			// 	console.log("— lastContent: null");
			// }
			// console.log("— newContent: "+newContent.id); // TRACE.
			if (!firstScrollDown) {
				// Fade out last section
				// console.log("— Fade out last section"); // TRACE.
				if(lastContent) {
					lastContent.leave();
				}
				
				// Animate in new section
				// console.log("— Animate in new section"); // TRACE.
				newContent.enter();
			} else {
				firstScrollDown = false;

				// Fade out last section
				// console.log("— Fade out last section"); // TRACE.
				if(lastContent) {
					lastContent.leave();
				}
				
				// Animate in new section
				// console.log("— Animate in new section"); // TRACE.
				newContent.enter();
			}
			
			lastContent = newContent;
		}
		
		prevScroll = currScroll;
	}

	// const media = window.matchMedia("screen and (max-width: 600px)");
	// ScrollTrigger.addEventListener("refreshInit", checkSTState);
	// checkSTState();

	// function checkSTState() {
	// 	if(media.matches) {
	// 		ST.disable();
	// 	} else {
	// 		ST.enable();
	// 	}
	// }

}

let $mySlider2 = $('.mobile .benefits-block__slides');

function initMobileSlider2() { // *** KEEP ***
    // console.log('BENEFITS: initMobileSlider2()'); // TRACE.
    let
        options = {
        	// centerMode:true,
        	// centerPadding:'105px',
        	cssEase:'ease-out',
            infinite:true,
            mobileFirst:true,
            slidesToShow:1,
            swipeToSlide:true,
            // slidesToScroll:1,
            swipe:false,
            swipeToSlide:false,
            arrows:true,
            prevArrow: $('.benefits-block__slides-arrow.prev'),
            nextArrow: $('.benefits-block__slides-arrow.next'),
            adaptiveHeight:false,
            responsive: [
                {
                    // breakpoint:1023,
                    // settings: "unslick"
                }
            ]
        };
    $mySlider2.slick(options);
}
function killMobileSlider2() { // *** KEEP ***
	// console.log('BENEFITS: killMobileSlider2()'); // TRACE.
	$mySlider2.slick('unslick');
}